/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Carriedoutsusworkshopinnerstrenght5Inputs */

const de__field_carriedoutsusworkshopinnerstrenght5 = /** @type {(inputs: _Field_Carriedoutsusworkshopinnerstrenght5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchgeführt Sus WorkshopInnerStrenght`)
};

/**

* @param {_Field_Carriedoutsusworkshopinnerstrenght5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_carriedoutsusworkshopinnerstrenght5 = /** @type {((inputs?: _Field_Carriedoutsusworkshopinnerstrenght5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Carriedoutsusworkshopinnerstrenght5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_carriedoutsusworkshopinnerstrenght5(inputs)
});
export { _field_carriedoutsusworkshopinnerstrenght5 as "_field_carriedOutSusWorkshopInnerStrenght" }